import React from 'react';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from '../../utils/downloadCsvFormConfig';
import { ContentPropsT } from '../../constants';
import useFilter from '../../utils/useFilterDownload';

const DownloadRefundCsvContent = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useFilter({
		handleFilterSubmit,
		onClose
	});

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Download',
					discardLabel: 'Cancel'
				}}
				hidePopUp
				validationSchema={validationSchema}
			/>
		</div>
	);
};

export default DownloadRefundCsvContent;
